export default __webpack_public_path__ + "static/media/Pass.95d5c9bf.mp3";